<template>
	<app>
		<crumb-bar :current="detailInfo.project_name"></crumb-bar>
		<module>
			<flow-node :node="nodeList" :current="currentNode" :reject="rejectNode"></flow-node>
			<c-title>安全台账详情</c-title>
			<c-detail>
				<c-detail-item label="所属项目名称" full>
					{{detailInfo.project_name}}
				</c-detail-item>
				<c-detail-item label="企业(施工)单位">
					{{detailInfo.zbqy_name}}
				</c-detail-item>
				<c-detail-item label="业主单位">
					{{detailInfo.yzdw_name}}
				</c-detail-item>
				<c-detail-item label="备注说明">
					{{detailInfo.remark}}
				</c-detail-item>
				<c-detail-item label="监理单位">
					{{detailInfo.jldw_name}}
				</c-detail-item>
				<c-detail-item label="审批材料">
					<c-file :src="detailInfo.file_path"></c-file>
				</c-detail-item>
				<c-detail-item label="签署状态">
					<span v-if="detailInfo.jl_qs_file_path && detailInfo.state == 1" style="color: goldenrod;">已上传(待审批)</span>
					<span v-else-if="detailInfo.jl_qs_file_path" style="color: #00B575;">已签署</span>
					<span v-else style="color: #1492FF;">待签署</span>
				</c-detail-item>
				<c-detail-item label="(监理)签署后文件" v-if="detailInfo.state == 1 && approveButton" full>
					<c-upload-file v-model="detailInfo.jl_qs_file_path" button="上传已盖章材料"  word="请上传签署好的材料文件"></c-upload-file>
				</c-detail-item>
				<c-detail-item v-if="(detailInfo.state != 1 && detailInfo.jl_qs_file_path) || detailInfo.yz_qs_file_path" label="签署后审批材料" full>
					<c-file :src="detailInfo.curr_file_path"></c-file>
				</c-detail-item>
			</c-detail>
			
			<c-title>审批流程</c-title>
			<c-detail>
				<c-detail-item label="审批记录" full>
					<timeline :data="timeline"></timeline>
				</c-detail-item>
			</c-detail>
			
			<c-button v-if="resubmitButton" slot="button" color="yellow" size="m" @click="$refs.ledgerEdit.open(detailInfo.id)">重新编辑</c-button>
			<div v-if="approveButton" slot="button" class="flex-center">
				<!-- <c-button v-if="signButton" size="m" width="300" @click="signHandle">签署</c-button> -->
				<c-button color="green" size="m" width="300" @click="signAqtz">审批通过</c-button>
				<c-button color="red" size="m" @click="$refs.approve.reject()">驳回</c-button>
			</div>
		</module>
		
		<ledger-edit v-if="power('7')" ref="ledgerEdit" @resolve="updateDetail"></ledger-edit>
		<approve ref="approve" @resolve="approveHandle"></approve>
	</app>
</template>

<script>
	import flowNode from '@/components/module/flow_node.vue'
	import timeline from '@/components/module/timeline.vue'
	import ledgerEdit from './ledger_edit.vue'
	import approve from '@/components/module/approve.vue'
	import {mapGetters} from 'vuex'
	
	export default {
		components: {
			flowNode,
			timeline,
			ledgerEdit,
			approve
		},
		
		props: {
			scene: String,
			id: String
		},
		
		data() {
			return {
				nodeList: [{
					name: '提交申请'
				}, {
					name: '(监理方)审批'
				}, {
					name: '(业主方)审批'
				}, {
					name: '办理完结'
				}],
				detailInfo: {},
				timeline: []
			}
		},
		
		computed: {
			...mapGetters(['power']),
			
			currentNode() {
				return this.detailInfo.state <= 3 ? this.detailInfo.state + 1 : 0;
			},
			
			rejectNode() {
				return this.detailInfo.state == 4 ? (this.detailInfo.reject_user_type == 8 ? 2 : 3) : 0;
			},
			
			resubmitButton() {
				return this.detailInfo.state == 4 && this.power('7');
			},
			
			signButton() {
				return !this.detailInfo.jl_qs_file_path;
			},
			
			approveButton() {
				return this.detailInfo.state == 1 && this.power('8');
			}
		},
		
		mounted() {
			this.updateDetail();
		},
		
		methods: {
			updateDetail() {
				this.request({
					url: '/project/aqtz/detail',
					data: {
						tz_id: this.id
					},
					success: data => {
						this.detailInfo = data.tzInfo;
						this.timeline = Array.from(data.logList, item => {
							return {
								date: item.create_date,
								content: `[${item.create_user_name}] ${item.remark}`
							}
						});
					}
				});
			},
			
			signAqtz(){
				if(!this.detailInfo.jl_qs_file_path){
					this.$message({
						text: '请上传签署好的安全台账文件'
					});
					return;
				}
				this.$refs.approve.resolve();
			},
			
			signHandle() {
				this.request({
					url: '/signature/fr/url',
					data: {
						businessType: 2,
						businessId: this.detailInfo.id
					},
					loading: true,
					success: data => {
						window.open(data);
						this.$confirm({
							text: '等待签署中',
							message: '签署完成请点击已完成签署按钮',
							buttonName: '已完成签署',
							resolve: () => {
								this.updateDetail();
							}
						});
					}
				});
			},
			
			approveHandle(state, remark, stop, next) {
				stop();
				this.request({
					url: '/project/aqtz/updateStateJl',
					data: {
						tz_id: this.id,
						state: state ? 2 : 4,
						jl_qs_file_path: this.detailInfo.jl_qs_file_path,
						jl_remark: remark
					},
					loading: true,
					success: data => {
						next();
						this.$message({
							text: '审批成功',
							resolve: () => {
								location.reload();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
